module.exports = __webpack_public_path__ + "static/media/AppStore.183780b4.png";